import api from "./api";

export const rolesService = {
  getAll() {
    return api.get("/roles");
  },
  getPermissions() {
    return api.get("/permissions");
  },
  create(payload) {
    return api.post("/roles", payload);
  },
  update(id, payload) {
    return api.patch(`/roles/${id}`, payload);
  },
};
